import api from "../../index";

export const GetAdminDashboardApi = () => api.post("admindashboard");
